.wrapper {
  position: relative;
  display: block;
  width: 100%;
}

.select {
  width: 100%;
  min-height: var(--touch-target);
  padding: 0 var(--space-6) 0 var(--space-3);
  appearance: none;
  background: var(--surface-raised);
  border: 1px solid var(--border-strong);
  border-radius: var(--radius-md);
  color: var(--text-primary);
  font-size: var(--text-base);
  transition: border-color var(--duration-fast) var(--ease-out);
}

.select:hover:not(:disabled) {
  border-color: var(--text-muted);
}

.select:disabled {
  background: var(--surface-sunken);
  color: var(--text-muted);
  cursor: not-allowed;
}

.invalid {
  border-color: var(--intent-danger);
}

.chevron {
  position: absolute;
  top: 50%;
  right: var(--space-3);
  width: var(--space-4);
  height: var(--space-4);
  transform: translateY(-50%);
  color: var(--text-muted);
  pointer-events: none;
}
